var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_111",
    "data-name": "Rectangle 111",
    width: 20,
    height: 9.137,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(-721 -439)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_112",
    "data-name": "Rectangle 112",
    width: 20,
    height: 20,
    transform: "translate(721 439)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(721 444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M5.188,9.176a5.452,5.452,0,0,1-2.134-.257A4.405,4.405,0,0,1,.027,5.079,4.517,4.517,0,0,1,3.89.113,5.218,5.218,0,0,1,4.633.065c1.144,0,2.287,0,3.431,0a4.553,4.553,0,0,1,4.6,3.785c.043.221.042.451.064.677a.915.915,0,0,1-.893,1.005.928.928,0,0,1-.934-.973A2.66,2.66,0,0,0,9.81,2.438a2.617,2.617,0,0,0-1.624-.546q-1.822-.011-3.644,0a2.726,2.726,0,0,0-.532,5.4,3.092,3.092,0,0,0,.592.056c.575.007,1.151,0,1.726,0a.9.9,0,0,1,.943.888.911.911,0,0,1-.924.937c-.334.007-.668,0-1.158,0",
    transform: "translate(0 -0.046)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M34.377,9.1c-.76,0-1.523.048-2.278-.01a4.481,4.481,0,0,1-3.964-3.45,5.338,5.338,0,0,1-.124-.989.912.912,0,0,1,.893-.984.941.941,0,0,1,.928.964,2.65,2.65,0,0,0,.921,1.986A2.622,2.622,0,0,0,32.52,7.3c1.236.011,2.472.016,3.708,0a2.723,2.723,0,0,0,.48-5.4,6.942,6.942,0,0,0-1.146-.057c-.39-.009-.781,0-1.172,0a.907.907,0,0,1-.925-.819.871.871,0,0,1,.81-.99,12.453,12.453,0,0,1,2.951.107,4.548,4.548,0,0,1-.38,8.928,17.494,17.494,0,0,1-2.084.061c-.128,0-.256,0-.384,0V9.1",
    transform: "translate(-20.733 0)",
    fill: "#1a1818"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.91c4755f48923c56247df66a07f394a1.svg";
export { ForwardRef as ReactComponent };